import { render } from "./Facebook.vue?vue&type=template&id=2f490b16"
import script from "./Facebook.vue?vue&type=script&lang=js"
export * from "./Facebook.vue?vue&type=script&lang=js"
script.render = render

export default script